import { ComponentSidebar, MobileSidebar } from "@components";
import { ILayout } from "@interfaces";
import { selectApp } from "@redux";
import { device } from "@utils";
import { Layout, Spin } from "antd";
import { useSelector } from "react-redux";
import styled from "styled-components";
const { Content } = Layout;

export const AppLayout = (props: ILayout) => {
  const { loading, mobile } = useSelector(selectApp);

  return (
    <StyledLayout>
      {!mobile && <ComponentSidebar />}
      <WrapperPages>
        <StyledContent>
          <Spin spinning={loading}>{props.children}</Spin>
        </StyledContent>
      </WrapperPages>
      <MobileSidebar />
    </StyledLayout>
  );
};
const WrapperPages = styled(Layout)`
  width: 100% !important;
  height: 100%;
`;
const StyledLayout = styled(Layout)`
  display: grid;
  grid-template-columns: 1fr 5fr;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;
const StyledContent = styled(Content)`
  margin: 0;
`;
